"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var classnames_1 = __importDefault(require("classnames"));
var Categories_1 = __importDefault(require("./Categories"));
var SortBy_1 = __importDefault(require("./SortBy"));
var Sidebar_1 = __importDefault(require("../Sidebar"));
var CollectionIcon_1 = __importDefault(require("./CollectionIcon"));
var ProductIcon_1 = __importDefault(require("./ProductIcon"));
var MobileFiltersMenu_1 = __importDefault(require("../MobileFiltersMenu"));
var selectors_1 = require("../../../common/selectors");
var atoms_1 = require("../../../styles/atoms");
var styled_components_1 = __importDefault(require("styled-components"));
var CloseIconSmall_1 = __importDefault(require("../../../common/Icons/CloseIconSmall"));
var GenericButton_1 = __importDefault(require("../../../common/GenericButton"));
var Filters = function () {
    var _a;
    var isCustomStore = (0, react_redux_1.useSelector)(selectors_1.isCustomStoreSelector);
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = (0, react_1.useState)(''), content = _c[0], setContent = _c[1];
    var _d = (0, react_1.useState)(false), isShowContent = _d[0], setIsShowContent = _d[1];
    (0, react_1.useEffect)(function () {
        if (isOpen) {
            document.documentElement.classList.add('store-menu-active');
        }
        else {
            document.documentElement.classList.remove('store-menu-active');
        }
    }, [isOpen]);
    var toggleMenu = function (newContent) { return function () {
        setIsOpen(!isOpen);
        setContent(newContent || content);
        if (!isShowContent) {
            setIsShowContent(true);
        }
        else {
            // анимация
            setTimeout(function () {
                setIsShowContent(false);
            }, 1000);
        }
    }; };
    var closeMenu = function () {
        setIsOpen(false);
        setTimeout(function () {
            setIsShowContent(false);
        }, 1000);
    };
    return (react_1.default.createElement(atoms_1.Div, { className: (0, classnames_1.default)((_a = {},
            _a['filters_custom-store'] = isCustomStore,
            _a)) },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(MobileFiltersMenu_1.default, null,
                content === 'sidebar' && (react_1.default.createElement(MobileSidebarContainer, null, isShowContent && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(MobileSidebarHeader, null,
                        react_1.default.createElement(atoms_1.Header3, null, "\u041A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438"),
                        react_1.default.createElement(StyledCloseIconSmall, { onClick: closeMenu })),
                    react_1.default.createElement(MobileSidebarBody, null,
                        react_1.default.createElement(Sidebar_1.default, { tagClick: toggleMenu() })),
                    react_1.default.createElement(StyledGenericButton, { onClick: toggleMenu(), size: 'large' }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C"))))),
                content === 'filters' && (react_1.default.createElement(MobileSidebarContainer, null, isShowContent && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(MobileSidebarHeader, null,
                        react_1.default.createElement(atoms_1.Header3, null, "\u0424\u0438\u043B\u044C\u0442\u0440\u044B"),
                        react_1.default.createElement(StyledCloseIconSmall, { onClick: closeMenu })),
                    react_1.default.createElement(MobileSidebarBody, null,
                        react_1.default.createElement(Categories_1.default, null),
                        react_1.default.createElement(SortBy_1.default, null)),
                    react_1.default.createElement(StyledGenericButton, { onClick: toggleMenu(), size: 'large' }, "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C")))))),
            react_1.default.createElement(MenuButtonsWrapper, null,
                !isCustomStore && (react_1.default.createElement(MenuButton, { onClick: toggleMenu('sidebar') },
                    react_1.default.createElement(CollectionIcon_1.default, null),
                    "\u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438")),
                react_1.default.createElement(MenuButton, { onClick: toggleMenu('filters') },
                    react_1.default.createElement(ProductIcon_1.default, null),
                    "\u0444\u0438\u043B\u044C\u0442\u0440\u044B")))));
};
var MenuButtonsWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: none;\n  justify-content: space-between;\n\n  @media (max-width: 940px), (hover: none) {\n    display: flex;\n  }\n"], ["\n  display: none;\n  justify-content: space-between;\n\n  @media (max-width: 940px), (hover: none) {\n    display: flex;\n  }\n"])));
var MenuButton = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  svg {\n    margin-right: 8px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  svg {\n    margin-right: 8px;\n  }\n"])));
var MobileSidebarHeader = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid ", ";\n\n  ", " {\n    flex: 1;\n    text-align: center;\n    padding-left: 24px;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid ", ";\n\n  ", " {\n    flex: 1;\n    text-align: center;\n    padding-left: 24px;\n  }\n"])), function (p) { return p.theme.colors.grayLight; }, atoms_1.Header3);
var MobileSidebarBody = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-y: scroll;\n  padding: 24px 20px 0px 20px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-y: scroll;\n  padding: 24px 20px 0px 20px;\n"])));
var StyledCloseIconSmall = (0, styled_components_1.default)(CloseIconSmall_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-left: auto;\n  cursor: pointer;\n"], ["\n  margin-left: auto;\n  cursor: pointer;\n"])));
var MobileSidebarContainer = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"])));
var StyledGenericButton = (0, styled_components_1.default)(GenericButton_1.default)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-top: 32px;\n  margin-bottom: 32px;\n  margin-left: 20px;\n  margin-right: 20px;\n"], ["\n  margin-top: 32px;\n  margin-bottom: 32px;\n  margin-left: 20px;\n  margin-right: 20px;\n"])));
exports.default = Filters;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
